import { TOUR_ASIA_CAMPAIGN, TOUR_V2_SEARCH_HERO_IMAGE_ASIA_CAMPAIGN } from 'constants/tours'
import Heading from 'LuxKit/Typography/Heading'
import moment from 'moment'
import React from 'react'
import TourAsiaCampaignHeroCarouselSubtitle from './components/TourAsiaCampaignHeroCarouselSubtitle'
import TourAsiaCampaignOfferBanner from './components/TourAsiaCampaignOfferBanner'
import TourAsiaCampaignProfileImage from './components/TourAsiaCampaignProfileImage'
import TourAsiaCampaignSearchBanner from './components/TourAsiaCampaignSearchBanner'
import TourAsiaCampaignTakeoverBackground from './components/TourAsiaCampaignTakeoverBackground'

const tourBestAsiaPromoTakeoverConfig: App.SiteTakeoverConfig = {
  id: 'tourbestasia',
  startDate: moment('2025-03-17T09:00:00+1100'),
  endDate: moment('2025-04-28T23:59:00+1100'),
  brands: new Set(['luxuryescapes']),
  regions: {
    type: 'inclusive',
    list: new Set(['AU', 'NZ', 'US', 'GB', 'FR', 'IT', 'ES', 'NL', 'DE', 'IE', 'CA']),
  },
  offerTypes: new Set(['direct_tour']),
  verticals: new Set(['tours']),
  campaignTags: new Set([TOUR_ASIA_CAMPAIGN]),
  imageId: TOUR_V2_SEARCH_HERO_IMAGE_ASIA_CAMPAIGN,
  palette: 'inverse',
  primaryColour: '',
  heroSection: {
    title: <Heading variant="heading2"><i>Explore</i> the best of Asia</Heading>,
    subtitle: <TourAsiaCampaignHeroCarouselSubtitle />,
    logo: <TourAsiaCampaignProfileImage />,
    palette: 'inverse',
    verticals: new Set(['tours']),
  },
  backgroundElement: TourAsiaCampaignTakeoverBackground,
  offerPage: {
    bannerContent: <TourAsiaCampaignOfferBanner />,
  },
  searchPage: {
    bannerContent: <TourAsiaCampaignSearchBanner />,
  },
}

export default tourBestAsiaPromoTakeoverConfig
